import _typeof from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/typeof.js";
import _asyncToGenerator from "/home/runner/work/alfarok-dev/alfarok-dev/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
// Copyright 2019-2022 @polkadot/wasm-bundle authors & contributors
// SPDX-License-Identifier: Apache-2.0
import { assert } from '@polkadot/util';
export function createWasmFn(root, wasmBytes, asmFn) {
  return /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(wbg) {
      var result, source;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              result = {
                error: null,
                type: 'none',
                wasm: null
              };
              _context.prev = 1;
              assert((typeof WebAssembly === "undefined" ? "undefined" : _typeof(WebAssembly)) === 'object' && typeof WebAssembly.instantiate === 'function' && wasmBytes && wasmBytes.length, 'WebAssembly is not available in your environment');
              _context.next = 5;
              return WebAssembly.instantiate(wasmBytes, {
                wbg: wbg
              });

            case 5:
              source = _context.sent;
              result.wasm = source.instance.exports;
              result.type = 'wasm';
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);

              // if we have a valid supplied asm.js, return that
              if (asmFn) {
                result.wasm = asmFn(wbg);
                result.type = 'asm';
              } else {
                result.error = "FATAL: Unable to initialize @polkadot/wasm-".concat(root, ":: ").concat(_context.t0.message);
                console.error(result.error);
              }

            case 13:
              return _context.abrupt("return", result);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10]]);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }();
}